export default __webpack_public_path__ + "static/press-mobile-784a67ccea4cdb4c3f09576c37b2eee8.png";